import {createValidator} from '../rules/createValidator';
import {required} from '../rules/required';

export const ipScreeningValidator = createValidator({
	itemValue: [required],
});
